<template>
  <div class="app-root">
    <router-view></router-view>

    <!-- setting drawer -->

    <v-navigation-drawer class="setting-drawer" temporary v-model="showSidebar">
      <theme-settings></theme-settings>
    </v-navigation-drawer>

    <!-- global snackbar -->

    <v-snackbar :timeout="3000" bottom right :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import ThemeSettings from '@/components/ThemeSettings'

export default {
  components: {
    ThemeSettings,
  },
  data() {
    return {
      showSidebar: false,
      snackbar: {
        show: false,
        text: '',
        color: '',
      },
    }
  },
  mounted() {},
  computed: {},
  methods: {
    openThemeSettings() {
      this.$vuetify.goTo(0)
    },
  },
}
</script>

<style scoped>
.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}
</style>
